/* unplugin-vue-components disabled */import { render } from "./signUp.vue?vue&type=template&id=4a295fce&scoped=true&ts=true"
import script from "./signUp.vue?vue&type=script&lang=ts"
export * from "./signUp.vue?vue&type=script&lang=ts"

import "./signUp.vue?vue&type=style&index=0&id=4a295fce&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a295fce"]])

export default __exports__